import React, { useState } from 'react';

import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import RestUtilities from '../../services/RestUtilities';
import queryString from 'query-string';
import isEmail from 'validator/lib/isEmail';
import InlineError from '../../components/Common/InlineError';
import { Grid, TextField, Box, Button, Typography } from '@mui/material';

export default function ResetPassword() {
  let location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(null);
  const [code, setCode] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [feedback, setFeedback] = useState('');

  if (!code) {
    const search = location.search;
    const parsed = queryString.parse(search);
    setCode(parsed.code);
  }
  const isEmailInvalid = !isEmail(email);
  const isPasswordInvalid = !!(password.length < 5 || password.length > 30);
  const hasErrors = isEmailInvalid || isPasswordInvalid;

  async function handleResetPasswordClick() {
    setDisabled(true);
    const url = '/api/auth/ResetPassword';
    const data = { email, password, code };
    var response = await RestUtilities.post(url, data);
    if (response.ok) {
      setFeedback(
        'Your password was reset. Please sign in using the new password.'
      );
    } else {
      response
        .json()
        .then((res) => {
          if (response.status === 400) {
            setErrors(res.errors ? res.errors : res);
            setFeedback('There were errors:');
            setDisabled(false);
          } else if (response.status === 401) {
            setFeedback('Oops. Something went wrong.');
            setDisabled(false);
            setErrors(null);
          }
        })
        .catch(() => {
          setFeedback('Oops. Something went wrong');
          setDisabled(false);
        });
    }
  }

  return (
    <form noValidate>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <TextField
            variant='outlined'
            required
            fullWidth
            value={email}
            id='email'
            label='Email Address'
            name='email'
            autoComplete='email'
            autoFocus
            onChange={(event) => {
              setEmail(event.target.value);
              setFeedback(null);
            }}
            error={!!email && isEmailInvalid}
            helperText={!!email && isEmailInvalid && 'Not an email address.'}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            minLength={5}
            maxLength={30}
            variant='outlined'
            required
            fullWidth
            value={password}
            name='password'
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
            onChange={(event) => {
              setPassword(event.target.value);
              setFeedback(null);
            }}
            error={!!password && isPasswordInvalid}
            helperText={
              !!password &&
              isPasswordInvalid &&
              'Must be minimum 5 characters and maximum of 30'
            }
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            variant='contained'
            color='secondary'
            sx={{ mt: 2 }}
            onClick={() => handleResetPasswordClick()}
            disabled={disabled || hasErrors}
          >
            Reset Password
          </Button>
        </Grid>
        {feedback && (
          <Grid item xs={12}>
            <Typography variant='body2'>{feedback}</Typography>
            <InlineError field='email' errors={errors} />
            <InlineError field='password' errors={errors} />
          </Grid>
        )}
      </Grid>
      <Box mt={3}>
        <Grid container justify='flex-end'>
          <Grid item xs>
            <Link to={'/forgotPassword'}>Forgot password?</Link>
          </Grid>
          <Grid item>
            <Link to={'/login'}>Sign in</Link>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
}
